export var KEY = '---------';
export default function separatorItem() {
  return {
    name: KEY
  };
}